// Inline tri-lingual helper for pages written with `isRu ? ru : en` ternaries.
// Chinese is looked up by the English string.
export const ZH = {
  "Link copied!": "链接已复制！",
  "🎁 Invite Friends": "🎁 邀请好友",
  "Share": "分享",
  "New player gets 500 Points bonus!": "新玩家可获得 500 Points 奖励！",
  "Stake (Points, 1 P = 1 ₽)": "赌注 (Points, 1 P = 1 ₽)",
  "Referrals": "推荐",
  "Active": "活跃",
  "Pending": "待定",
  "Total": "总计",
  "Your level": "您的等级",
  "To next level": "距下一等级",
  "Next payout": "下次结算",
  "en-US": "zh-CN",
  "Earnings": "收益",
  "💰 Earnings History": "💰 收益记录",
  "No earnings yet": "暂无收益",
  "Deposited": "已充值",
  "Paid": "已支付",
  "👥 Your Referrals": "👥 您推荐的用户",
  "No referrals yet": "暂无推荐用户",
  "Deposits:": "充值：",
  "Inactive": "不活跃",
  "Ready to Play?": "准备好开始了吗？",
  "All rights reserved.": "版权所有。",
  "vs Bot": "对战机器人",
  "Money Tournaments": "真钱锦标赛",
  "Create": "创建",
  "Refresh": "刷新",
  "Play for Real Money": "真钱对弈",
  "Win and withdraw to your card": "赢取奖金并提现到银行卡",
  "10 Difficulty Levels": "10 个难度等级",
  "From beginner to grandmaster": "从新手到特级大师",
  "ELO Rating & Leagues": "ELO 等级分与联赛",
  "Compete with players of your level": "与同水平的棋手竞技",
  "Invite Friends": "邀请好友",
  "Earn 3%+ from every friend's deposit": "好友每次充值您可获得 3% 起",
  "Tournaments with Prizes": "有奖锦标赛",
  "Swiss and Arena formats": "瑞士制与竞技场赛制",
  "Available games": "可加入的对局",
  "Join": "加入",
  "Game created!": "对局已创建！",
  "No increment": "无加秒",
  "Play vs Bot": "对战机器人",
  "10 difficulty levels": "10 个难度等级",
  "Bot Level": "机器人等级",
  "Easier": "更简单",
  "Harder": "更难",
  "Beginner": "新手",
  "Casual": "休闲",
  "Medium": "中等",
  "Strong": "强手",
  "Expert": "专家",
  "Choose Color": "选择棋色",
  "White": "白方",
  "First move": "先手",
  "Random": "随机",
  "Color picked automatically": "自动选择棋色",
  "Black": "黑方",
  "Second move": "后手",
  "Time Control": "时间控制",
  "Game time": "对局时间",
  "Increment": "加秒",
  "min": "分钟",
  "Win": "胜",
  "Loss": "负",
  "Draw": "和",
  "Game History": "对局历史",
  "PvP matches and statistics": "玩家对局与统计",
  "History": "历史",
  "Statistics": "统计",
  "No completed games": "暂无已完成的对局",
  "Find Game": "寻找对局",
  "moves": "步",
  "Total Games": "总对局数",
  "Win Rate": "胜率",
  "Wins": "胜场",
  "Draws": "和棋",
  "Losses": "负场",
  "Finances": "财务",
  "Won": "赢得",
  "Lost": "输掉",
  "Net": "净收益",
  "Current Rating": "当前等级分",
  "Highest": "最高",
  "No data": "暂无数据",
  "Game Analysis": "对局分析",
  "Rematch": "再来一局",
  "Code sent": "验证码已发送",
  "Check your Telegram": "请查看您的 Telegram",
  "Error": "错误",
  "Failed to send code": "发送验证码失败",
  "Network error": "网络错误",
  "Passwords don't match": "两次密码不一致",
  "Password must be at least 6 characters": "密码至少 6 个字符",
  "Password changed": "密码已更改",
  "Invalid code": "验证码无效",
  "Back to login": "返回登录",
  "Done!": "完成！",
  "Password Recovery": "找回密码",
  "Enter email to get code via Telegram": "输入邮箱，通过 Telegram 获取验证码",
  "Enter code from Telegram and new password": "输入 Telegram 验证码和新密码",
  "Your password has been changed": "您的密码已更改",
  "Email": "邮箱",
  "Sending...": "发送中...",
  "Send Code": "发送验证码",
  "Code from Telegram": "Telegram 验证码",
  "New Password": "新密码",
  "Confirm Password": "确认密码",
  "Back": "返回",
  "Change": "更改",
  "Resend code": "重新发送验证码",
  "Login": "登录",
  "Invalid amount": "金额无效",
  "Minimum amount is 50 ₽": "最低金额 50 ₽",
  "Redirecting to payment page...": "正在跳转到支付页面...",
  "Deposit failed": "充值失败",
  "Invalid card number": "卡号无效",
  "Withdrawal failed": "提现失败",
  "Fill all fields": "请填写所有字段",
  "Invalid phone number": "手机号无效",
  "Phone topped up!": "话费充值成功！",
  "Top-up failed": "充值失败",
  "Select card": "选择礼品卡",
  "Coming soon!": "即将推出！",
  "Card purchased!": "礼品卡购买成功！",
  "Purchase failed": "购买失败",
  "Balance (Points)": "余额 (Points)",
  "Deposit": "充值",
  "Withdraw": "提现",
  "Services": "服务",
  "Mobile": "手机",
  "Phone top-up": "话费充值",
  "Gift Cards": "礼品卡",
  "To Card": "转到银行卡",
  "More": "更多",
  "Soon": "即将推出",
  "No transactions": "暂无交易",
  "pending": "待处理",
  "failed": "失败",
  "Choose amount and payment method": "选择金额和支付方式",
  "Or enter amount": "或输入金额",
  "Bank Card": "银行卡",
  "To bank card": "转到银行卡",
  "Amount": "金额",
  "Available": "可用",
  "Card Number": "卡号",
  "Mobile Top-up": "话费充值",
  "Select country": "选择国家",
  "Select operator": "选择运营商",
  "Phone Number": "手机号",
  "Other amount": "其他金额",
  "Balance": "余额",
  "cost": "费用",
  "Top Up": "充值",
  "Cards": "礼品卡",
  "Value": "面值",
  "Insufficient balance": "余额不足",
  "Buy for": "购买价格",
  "Card Transfer": "银行卡转账",
  "Coming Soon!": "即将推出！",
  "Terms of Service": "服务条款",
  "Stake": "赌注",
  "Free": "免费",
  "Free game": "免费对局",
  "Create Game": "创建对局",
  "Cancel": "取消",
  "Players online": "在线玩家",
  "Your balance": "您的余额",
  "Find match": "寻找对手",
  "Searching...": "搜索中...",
  "Play with bot": "与机器人对弈",
  "Play Now": "立即开始",
  "Standings": "排名",
  "Participants": "参赛者",
  "Prize pool": "奖池",
  "Entry fee": "报名费",
  "Rating": "等级分",
  "League": "联赛",
  "Games": "对局",
  "Points": "积分",
  "Leaderboard": "排行榜",
  "Your color": "您的棋色",
  "Payment failed": "支付失败",
  "Waiting for payment": "等待付款",
  "Scan the QR code in your bank app and confirm the payment. Your balance updates automatically — keep this page open.": "请在银行应用中扫描二维码并确认付款。余额将自动更新——请保持此页面打开。",
  "Complete the payment on the bank page. Your balance updates automatically.": "请在银行页面完成付款。余额将自动更新。",
  "Open payment page": "打开付款页面",
  "Close": "关闭",
  "Click “Open payment page”": "请点击“打开付款页面”",
  "Play for Money": "真钱对局",
  "Find an opponent and compete for real stakes": "寻找对手，进行真钱对弈",
  "Your Balance (Points)": "您的余额 (Points)",
  "Searching for opponent...": "正在寻找对手...",
  "No opponents found. Play against a bot at your level?": "未找到对手。与同水平的机器人对弈？",
  "Play with Bot": "与机器人对弈",
  "Cancel Search": "取消搜索",
  "Game Settings": "对局设置",
  "Quick Play": "快速对局",
  "Instant match - human or bot": "即时匹配 — 真人或机器人",
  "Fair Matching": "公平匹配",
  "±200 rating range": "±200 等级分范围",
  "5% Fee": "5% 手续费",
  "Platform commission": "平台佣金",
  "AI monitoring": "AI 监控",
  "Anti-Cheat": "反作弊",
  "Online": "在线",
  "Offline": "离线",
  "Earn": "好友每次充值您获得",
  "from every deposit!": "",
  "Winrate": "胜率",
  "Players Online": "在线玩家",
  "Deposit funds": "充值",
  "Withdraw funds": "提现",
  "3300+ ELO · stronger than the world champion": "3300+ ELO · 强于世界冠军",
  "Play vs": "对战",
  "Promote to": "升变为",
  "Queen": "后",
  "Rook": "车",
  "Bishop": "象",
  "Knight": "马",
  "Promote to": "升变为",
  "No streak": "无连胜",
  "wins in a row": "连胜",
  "losses in a row": "连败",
  "draws in a row": "连和",
  "Elo Rating": "Elo 等级分",
  "Max": "最高",
  "Min": "最低",
  "games": "局",
  "Rating history": "等级分历史",
  "Average opponent rating": "对手平均等级分",
  "to": "距",
  "Your League": "您的联赛",
  "rating": "等级分",
  "Progress to": "晋级进度：",
  "Remaining": "还需",
  "points": "分",
  "League rank": "联赛排名",
  "Players in league": "联赛人数",
  "All leagues:": "所有联赛：",
  "You have an active game": "您有一局正在进行的对局",
  "Opponent found!": "已找到对手！",
  "KYC verification is required for money games": "真钱对局需要完成身份验证 (KYC)",
  "Searching for an opponent...": "正在寻找对手...",
  "Could not start search": "无法开始搜索",
  "Search cancelled": "已取消搜索",
  "Playing against": "对战",
  "Bot": "机器人",
  "Could not start a bot game": "无法开始机器人对局",
  "Quick play unavailable": "快速对局不可用",
  "Play for": "下注",
  "Play Free Game": "免费对局",
  "You are registered!": "报名成功！",
  "Tournament not found": "未找到锦标赛",
  "Back to tournaments": "返回锦标赛",
  "Registration": "报名中",
  "Live": "进行中",
  "Finished": "已结束",
  "Find opponent": "寻找对手",
  "players": "名玩家",
  "time control": "时间控制",
  "round": "轮次",
  "entry fee": "报名费",
  "prize pool": "奖池",
  "Pairings": "对阵",
  "Tournament standings": "锦标赛排名",
  "Tournament has not started yet": "锦标赛尚未开始",
  "Player": "棋手",
  "Buchholz": "布赫霍尔茨",
  "You": "您",
  "Round": "第",
  "Current games": "当前对局",
  "Pairings will appear once the tournament starts": "锦标赛开始后将显示对阵",
  "No active games": "暂无进行中的对局",
  "Waiting": "等待中",
  "Watch": "观看",
};

export const makeTr = (language) => (ru, en) => {
  if (language === "ru") return ru;
  if (language === "zh") return ZH[en] ?? en;
  return en;
};
